import { render } from "./TaskCounter.vue?vue&type=template&id=2f170d04&scoped=true"
import script from "./TaskCounter.vue?vue&type=script&lang=js"
export * from "./TaskCounter.vue?vue&type=script&lang=js"

import "./TaskCounter.vue?vue&type=style&index=0&id=2f170d04&scoped=true&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f170d04"]])

export default __exports__